(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        $(function () {
            var $selectName = $('.calendar-city-select-name');
            var $fromCity = $selectName.find('.from-label');
            var $cityName = $selectName.find('.city');
            var linkTemplate = '/tury#month##departCity#.html';
            var isAllowAjaxUpdate = false;

            function createLink(departCity, month) {
                var link = linkTemplate;

                month = month ? '/' + month : '';
                departCity = departCity ? '/iz-' + departCity : '';

                link = link.replace('#month#', month);
                link = link.replace('#departCity#', departCity);

                return link;
            }

            function updateCountriesList(link) {
                $.get(link).done(function (response) {
                    $('.tours-destination-countries-list').replaceWith(response);
                });
            }

            $('.select-month').click(function (event) {
                if (!isAllowAjaxUpdate) {
                    // Пока делаем чтобы страница обновлялась сразу (Инна передумала)
                    return;
                }
                event.preventDefault();
                $('.select-month').removeClass('active');

                var $this = $(this);
                $this.addClass('active');

                var month = $(this).data('alias');
                var departCity = $cityName.data('alias');
                var link = createLink(departCity, month);
                updateCountriesList(link);
            });

            $('.calendar-city-select').click(function (event) {
                if (!isAllowAjaxUpdate) {
                    // Пока делаем чтобы страница обновлялась сразу (Инна передумала)
                    return;
                }
                event.preventDefault();

                var name = $(this).data('name');
                var departCity = $(this).data('alias');
                var month = null;

                var $activeMonth = $('.select-month.active');
                if ($activeMonth.length) {
                    month = $activeMonth.data('alias');
                }
                var link = createLink(departCity, month);
                updateCountriesList(link);

                $cityName.html(name);
                $cityName.data('alias', departCity);

                $('.calendar-city-select').find('a').removeClass('active');
                $(this).find('a').addClass('active');

                $fromCity.html('Город вылета:');
            });
            $('.tours-destination').on('click', '.show-hidden-countries', function (e) {
                e.preventDefault();
                $(this).remove();
                $('.has-no-price').removeClass('hidden');
            });
        });
    }, {}] }, {}, [1]);